import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, ActivatedRoute } from '@angular/router';
import {Observable, Subscription} from 'rxjs';
import {AuthService} from "./auth.service";
import {UserRole} from "../interfaces/user";

@Injectable({
  providedIn: 'root'
})
export class AuthGuard {

  private lastsub: Subscription = null;

  constructor(private auth: AuthService,
              private route: ActivatedRoute,
              private router: Router) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    if(!this.auth.loggedIn){
      this.router.navigate(['login'], {
        // queryParams: {redirect: this.router.url ?? null}
      });
      return false;
    }

    return new Promise<boolean>((resolve, reject) => {
      if(this.lastsub){
        this.lastsub.unsubscribe();
      }

      this.lastsub = this.auth.user.subscribe(async (user) => {
        if(user){
          const roles = route.data && route.data.roles ? route.data.roles as Array<UserRole> : null;
          if(roles && roles.indexOf(user.user_to_client?.role) === -1){
            console.warn('AuthGuard blocked route for role mismatch', {
              url: state.url,
              role: user.user_to_client?.role,
              allowedRoles: roles,
            });
            // '/users/me' carries no role restriction, so it's guaranteed
            // terminal — market-vacancies would re-block (and loop) for a
            // role-NA user or one with no client membership.
            this.router.navigate(['/users/me']);
            return resolve(false);
          }
          return resolve(true);
        }
      });
    });
  }

}
